var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchbar"},[_c('div',{staticClass:"wrap"},[_vm._t("default"),_c('div',{staticClass:"button-area"},[_c('b-button',{attrs:{"type":"is-info"},on:{"click":_vm.onSearchClick}},[_vm._v("検索")])],1)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }